import React, { useEffect, useState } from 'react';
import {
	Popper,
	Grow,
	Typography,
	List,
	ListItem,
	Checkbox,
	Paper,
	ClickAwayListener,
	FormControlLabel,
	Button,
	Link,
	Box,
	Tooltip,
	ListItemText,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OKRButton } from '../../../../Common/OKRButton';
import { NewFilterIcon } from '../../../../../config/svg/CommonSvgIcon';
import { DownArrowIcon, UpArrowIcon } from '../../../../../config/svg/ArrowSvg';
import { BorderCheckboxIcon, CheckedIcon } from '../../../../../config/svg/formElementIcons';

export const DefaultKpiFilter: React.FC<any> = (props) => {
	const {
		categories,
		setFinalFilterCondition,
		finalFilterCondition,
		defaultSearchFilter,
		appliedFilter,
		setAppliedFilter,
	} = props;
	const { t } = useTranslation();

	const {} = props;
	const [localFilterCondition, setLocalFilterCondition] = useState<any>({ ...defaultSearchFilter });
	const statusCategory: any[] = [
		{
			id: 1,
			name: 'Draft',
		},
		{
			id: 2,
			name: 'Published',
		},
	];

	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleToggleFilter = (event: any) => {
		setAnchorEl(event.currentTarget);
		setOpenFilter((prev) => !prev);
	};

	const handleClose = (event: any) => {
		setAnchorEl(null);
		setOpenFilter(false);
	};

	const handleFilterChanged = (value: number, key: string) => {
		let filterData: any = { ...localFilterCondition };
		let indexParent = filterData[key].indexOf(value);
		if (indexParent === -1) {
			filterData[key].push(value);
		} else {
			filterData[key].splice(indexParent, 1);
		}
		setLocalFilterCondition(filterData);
	};

	const handleApplyFilterClick = (filtersData: any) => {
		setAppliedFilter(true);
		setFinalFilterCondition({ ...localFilterCondition });
	};

	return (
		<Box className='filter-list-dropdown kpi-filter-list-dropdown'>
			{/* <Box className={`filter-chip `}>
				{appliedFilter && (
					<List>
						{finalFilterCondition && finalFilterCondition.length > 0 ? (
							<>
								{finalFilterCondition.slice(0, 1).map((item: any, index: any) => (
									<ListItem key={index}>
										<Tooltip arrow title={item.name}>
											<Typography variant='body2'>{item.name}</Typography>
										</Tooltip>
										<Button className='cancel-btn' onClick={() => handleCloseChip(item)}>
											<CancelIcon />
										</Button>
									</ListItem>
								))}
								{finalFilterCondition.length > 1 && (
									<ListItem className='more-filter-count'>
										<Typography variant='body2'>+{finalFilterCondition.length - 1}</Typography>
									</ListItem>
								)}

								<ListItem className='clear-all'>
									<Link onClick={clearFilter}>{t('clearAll')}</Link>
								</ListItem>
							</>
						) : (
							<></>
						)}
					</List>
				)}
			</Box> */}
			<OKRButton
				className={`list-filter-btn ${openFilter ? 'active' : ''}`}
				icon={<NewFilterIcon />}
				text={
					<span className='filter-txt'>
						{t('filterLabel')}
						{openFilter ? <UpArrowIcon /> : <DownArrowIcon />}
					</span>
				}
				handleClick={handleToggleFilter}
				id='dashboard-filter-btn'
			/>
			<Popper
				className={`okr-filter alignmentmap-filter-list kpi-filter-list`}
				open={openFilter}
				anchorEl={anchorEl}
				id='workflow-reversal-filter'
				placement={'bottom-end'}
				modifiers={{
					flip: {
						enabled: false,
					},
				}}
			>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<ClickAwayListener onClickAway={handleClose}>
							<Paper>
								<Box className='alignmentFilterWrap'>
									<Box className='okr-type-filter'>
										<Typography variant='body2'>{t('byStatus')}:</Typography>
										<List disablePadding>
											{statusCategory &&
												statusCategory.length &&
												statusCategory.map((item: any, index: any) => {
													return (
														<>
															<ListItem>
																<FormControlLabel
																	control={
																		<Checkbox
																			icon={<BorderCheckboxIcon />}
																			checkedIcon={<CheckedIcon />}
																			checked={
																				localFilterCondition.status && localFilterCondition.status.includes(item.id)
																			}
																			value={item.id}
																			onChange={(e) => handleFilterChanged(item.id, 'status')}
																			color='primary'
																		/>
																	}
																	label={item?.name}
																/>
															</ListItem>
														</>
													);
												})}
										</List>
									</Box>
									<Box className='okr-type-filter'>
										<Typography variant='body2'>{t('byCategory')}:</Typography>
										<List disablePadding>
											{categories &&
												categories.length &&
												categories.map((item: any, index: any) => {
													return (
														<>
															<ListItem>
																<FormControlLabel
																	control={
																		<Checkbox
																			icon={<BorderCheckboxIcon />}
																			checkedIcon={<CheckedIcon />}
																			checked={
																				localFilterCondition?.kpiCategoryMasterId &&
																				localFilterCondition?.kpiCategoryMasterId.includes(item.kpiCategoryMasterId)
																			}
																			value={item.kpiCategoryMasterId}
																			onChange={(e) =>
																				handleFilterChanged(item.kpiCategoryMasterId, 'kpiCategoryMasterId')
																			}
																			color='primary'
																		/>
																	}
																	label={item?.name}
																/>
															</ListItem>
														</>
													);
												})}
										</List>
									</Box>
								</Box>
								<Box className='filter-list-actions'>
									<OKRButton
										className='apply-btn btn-primary'
										text={t('applyLabel')}
										handleClick={(e: any) => {
											handleClose(e);
											handleApplyFilterClick(localFilterCondition);
										}}
									/>
								</Box>
							</Paper>
						</ClickAwayListener>
					</Grow>
				)}
			</Popper>
		</Box>
	);
};
